export class ItemPresenter {
    constructor(model, formConstructor, viewPageContainer, viewItemConstructor, modal) {
        this.model = model;
        this.formConstructor = formConstructor;
        this.viewPageContainer = viewPageContainer;
        this.viewItemConstructor = viewItemConstructor;
        this.modal = modal;
        this.itemTemplate = document.querySelector("#todo-item-template");
        this.formTemplate = document.querySelector("#todo-form-template");
    }
    init() {
        this.todoForm = new this.formConstructor(this.formTemplate);
        this.todoForm.setHandler(this.handleSubmitForm.bind(this));
        // this.todoForm.buttonText = "Добавить";
        this.todoForm.placeholder = "Следующее дело";
        this.viewPageContainer.formContainer = this.todoForm.render();
        this.todoEditForm = new this.formConstructor(this.formTemplate);
        // this.todoEditForm.buttonText = "Изменить";
        this.todoEditForm.placeholder = "Новое название";
    }
    handleSubmitForm(data) {
        this.model.addItem(data);
        this.todoForm.clearValue();
        this.renderView();
    }
    handleSubmiteEditForm(data, id) {
        this.model.editItem(id, data);
        this.renderView();
        this.todoEditForm.clearValue();
        this.modal.close();
    }
    handleCopyItem(item) {
        const copiedItem = this.model.getItem(item.id);
        this.model.addItem(copiedItem.name);
        this.renderView();
    }
    handleDeleteItem(item) {
        this.model.removeItem(item.id);
        this.renderView();
    }
    handleEditItem(item) {
        const editedItem = this.model.getItem(item.id);
        this.todoEditForm.setValue(editedItem.name);
        this.modal.content = this.todoEditForm.render();
        this.todoEditForm.setHandler((data) => this.handleSubmiteEditForm(data, item.id));
        this.modal.open();
    }
    renderView() {
        const itemList = this.model.items
            .map((item) => {
            const todoItem = new this.viewItemConstructor(this.itemTemplate);
            todoItem.setCopyHandler(this.handleCopyItem.bind(this));
            todoItem.setDeletedHandler(this.handleDeleteItem.bind(this));
            todoItem.setEditHandler(this.handleEditItem.bind(this));
            const itemElement = todoItem.render(item);
            return itemElement;
        })
            .reverse();
        this.viewPageContainer.todoContainer = itemList;
    }
}
